<template>
  <div>
    <mk-upload-oss
      ref="upload"
      :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
      :multiple="true"
      :headers="headers"
      :limit="9"
      v-bind="$attrs"
      :on-exceed="onExceed"
      @on-upload="imageUpload"
    >
      <template v-slot:trigger>
        <div ref="fileUploadOss" />
      </template>
    </mk-upload-oss>
    <upload-progress
      :visible.sync="visible"
      :file-list.sync="fileList"
      :error-length.sync="errorLength"
      :upload-status.sync="uploadStatus"
    ></upload-progress>
  </div>
</template>

<script>
import UploadProgress from '../upload-progress'
export default {
  name: 'MutiUpload',
  components: {
    UploadProgress
  },
  data () {
    return {
      // 上传进度弹窗是否可见
      visible: false,
      fileList: [],
      // 用于存放文件在fileList里面的位置，用于上传时更新进度
      fileMap: {},
      // 用于判断是否上传完毕
      fileCount: 0,
      errorLength: 0,
      // 上传的状态
      uploadStatus: 0,
      // 设置阿里云返回头部参数，表明已附件形式下载
      headers: {
        'Content-Disposition': `attachment`,
        'Content-Type': `application/octet-stream`
      },
      // 文件类型map表
      fileTypeMap: {
        doc: 1,
        docx: 1,
        xls: 2,
        xlsx: 2,
        pdf: 3,
        txt: 4,
        ppt: 5,
        pptx: 5,
        jpg: 6,
        png: 6,
        jpeg: 6,
        jfif: 6,
        gif: 6,
        bmp: 6,
        pjp: 6,
        pjpeg: 6,
        mp3: 7,
        wma: 7,
        wav: 7,
        amr: 7,
        m4a: 7,
        mp4: 8
      }
    }
  },
  methods: {
    imageUpload (res) {
      let { type, file } = res
      let { size } = file
      let { name, suffix } = this.getFileNameAndSuffix(file)
      // 文件上传之前
      if (type === 'before') {
        this.uploadStatus = 0
        if (!this.visible) this.visible = true
        this.fileMap[name + size] = this.fileList.length
        let tarSuffix = suffix.split('.')[1]
        // name超过20位截取前20
        let limitName = name.slice(0, 20)
        limitName = limitName.replace(/,/g, '-')
        this.fileList.push({
          name: limitName,
          suffix: tarSuffix,
          url: '',
          directory: '',
          size: size,
          fileType: this.getFileType(tarSuffix),
          progress: 0,
          // 文件是否上传成功
          status: true
        })
        this.fileCount++
      }
      if (type === 'progress') {
        let index = this.fileMap[name + size]
        this.fileList[index].progress = Math.ceil(res.result.progress * 100)
      }
      if (type === 'success' || type === 'fail') {
        let index = this.fileMap[name + size]
        if (type === 'success') {
          let url = res.result.url
          this.fileList[index].url = url
          this.fileList[index].directory = url.split('aliyuncs.com/')[1]
        } else {
          this.fileList[index].status = false
          this.errorLength++
        }

        this.fileCount--
        // 上传完成，再存到我们的后台
        if (this.fileCount === 0) {
          this.onUploadFinish(this.fileList)
        }
      }
    },
    // 上传结束后，上传到后台
    onUploadFinish (fileList) {
      let data = this._.cloneDeep(fileList)
      let successData = []
      data.forEach((item) => {
        // 上传成功的文件才存储
        if (item.status) {
          delete item.progress
          delete item.status
          successData.push(item)
        }
      })
      this.ordinaryPost(successData)
    },
    // 创建普通素材
    async ordinaryPost (materialArr) {
      let params = {
        materialArr
      }
      let res = await MKMATERIALSVC.OrdinaryApi.ordinaryPost(params)
      this.uploadStatus = 1
      // 上传成功过，则整体成功，失败则全部失败
      if (res.success) {
        this.$emit('finish')
        setTimeout(() => {
          this.visible = false
        }, 2000)
      } else {
        this.errorLength = this.fileList.length
      }
      // 文件上传成功之后，清空upload组件内部的文件数据，不然会造成下一次上传超出限制
      this.$refs.upload.$children[0].clearFiles()
    },
    // 获取上传文件的后缀名
    getFileNameAndSuffix (file) {
      const index = file.name.lastIndexOf('.')
      // 文件名
      const name = file.name.substr(0, index)
      // 文件类型（就是后缀png、jpeg等等）
      const suffix = file.name.substr(index).toLocaleLowerCase()
      return { name, suffix }
    },
    upload () {
      this.$refs.fileUploadOss.click()
    },
    // 返回文件的类型
    getFileType (suffix) {
      let fileType = this.fileTypeMap[suffix] ? this.fileTypeMap[suffix] : 1
      return fileType
    },
    // 文件上传超出9个时候
    onExceed () {
      this.$message.error('最多上传9个文件')
    }
  }
}
</script>
